<template>
	<div class="footer">
		<div class="footer-main">
			<div class="bg">
				<img src="../assets/images/bg/footerbg.jpg" alt="">
			</div>
			<div class="main-top-nei">
				
				<div class="main-top-nei-left">
					<div class="main-top-nei-left-name">联系我们:</div>
					<div class="main-top-nei-left-bottom">
						<div class="main-top-nei-left-bottom-one" style="cursor: pointer;" @click="goEmail">
							<span>E-mail:</span>
							<span class="emil1">hongketansu@163.com</span>
							<!-- <span class="emil2">arlene.jia@aohaicarbon.com</span> -->
						</div>
						<div class="main-top-nei-left-bottom-two">
							<div class="main-top-nei-left-bottom-two-item">
								<span>人力资源:</span>
								<span class="phone">+86-13603116540</span>
							</div>
							<div class="main-top-nei-left-bottom-two-item">
								<span>国内销售部:</span>
								<span class="phone">+86-13933115065</span>
							</div>
							<div class="main-top-nei-left-bottom-two-item">
								<span>国际销售部:</span>
								<span class="phone">+86-13933115065</span>
							</div>
						<!-- 	<div class="main-top-nei-left-bottom-two-item">
								<span>供应部:</span>
								<span class="phone">+86-531-87747140</span>
							</div> -->
						</div>
						<div class="main-top-nei-left-bottom-three">
							<div class="main-top-nei-left-bottom-three-item">
								<span>版权所有:</span>
								<span class="main-top-nei-left-bottom-three-item-right">河北鸿科碳素有限公司</span>
							</div>
							<div class="main-top-nei-left-bottom-three-item">
								<span>备案号:</span>
								<span class="main-top-nei-left-bottom-three-item-right"  style="cursor: pointer;" @click="gobeian">冀ICP备17012034号-1</span>
							</div>
							<div class="main-top-nei-left-bottom-three-item">
								<span>公网安备号:</span>
								<span class="main-top-nei-left-bottom-three-item-right" style="cursor: pointer;" @click="goGonganBeian">冀公网安备13010702000050号</span>
							</div>
						</div>

					</div>
				</div>
				<div class="main-top-nei-right">
					<!-- <img src="../assets/images/login/login3.jpg" alt=""> -->
				</div>
			</div>


		</div>
	</div>
</template>

<script>
	export default {
		name: "Footer",
		props: {
			msg: String
		},
		data() {
			return {

			}
		},
		methods:{
			goEmail(){
				window.open('https://mail.163.com/')
			},
			gobeian(){
				window.open('https://beian.miit.gov.cn/#/Integrated/index')
			},
			goGonganBeian(){
				window.open('https://beian.mps.gov.cn/#/query/webSearch?code=13010702000050')
			}
		}
	};
</script>
<style scoped>
	.router-link-active {
		text-decoration: none;
		color: white;
	}

	a {
		text-decoration: none;
		color: white;
	}
</style>

<style scoped lang="less">
	

	.footer-main {
		
		width: 100%;
		height: 250px;
		position: relative;
		.bg {
			position: absolute;
			width: 100%;
			height: 100%;
			top: 0;
			left: 0;
		
			img {
				width: 100%;
				height: 100%;
			}
		}

		
		.main-top-nei {
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			margin: 0 auto;
			width: 1360px;
			padding-top: 20px;
			padding-bottom: 66px;
			height: 100%;
			color: #fff;
			display: flex;
			align-items: center;
			justify-content: space-between;

			.main-top-nei-left {
				color: #fff;

				.main-top-nei-left-name {
				
					font-size: 24px;
				}

				.main-top-nei-left-bottom {
					margin-top: 24px;
					font-size: 16px;

					.main-top-nei-left-bottom-one {
						margin-bottom: 16px;

						.emil1 {
							margin: 0 16px;
						}
					}

					.main-top-nei-left-bottom-two {
						display: flex;
						align-items: center;
						margin-bottom: 26px;

						.main-top-nei-left-bottom-two-item {
							margin-right: 8px;

							.phone {
								margin-left: 16px;
							}
						}
					}

					.main-top-nei-left-bottom-three {
						display: flex;
						align-items: center;

						.main-top-nei-left-bottom-three-item {
							margin-right: 8px;

							.main-top-nei-left-bottom-three-item-right {
								margin-left: 8px;
							}
						}

					}
				}
			}

			.main-top-nei-right {
				width: 170px;
				height: 170px;
				margin-top: 37px;

				img {
					vertical-align: top;
					width: 100%;
					height: 100%;
				}
			}



		}





	}
</style>
